$(document).ready(function() {
  jQuery(".best_in_place").best_in_place();
});
